import { createApi } from '@reduxjs/toolkit/query/react';

import type { IDifferenceCheckerData } from '../types/IDifferenceChecker';

import { axiosBaseQuery } from '@/redux/axios';

export type JourneyComparisonResponse = IDifferenceCheckerData;

export interface GetJourneyComparisonParams {
  fromDate?: string;
  toDate?: string;
  contractIds?: string[];
}

export const comparisonApi = createApi({
  reducerPath: 'comparisonApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['JourneyComparison'],
  endpoints: (builder) => ({
    getJourneyComparison: builder.query<
      JourneyComparisonResponse,
      GetJourneyComparisonParams
    >({
      query: ({ fromDate, toDate, contractIds }) => {
        const params = new URLSearchParams();
        if (fromDate) {
          params.append('FromDate', fromDate);
        }
        if (toDate) {
          params.append('ToDate', toDate);
        }
        contractIds?.forEach((id) => params.append('ContractId', id));
        const queryString = params.toString();
        return {
          url: queryString
            ? `Journeys/comparison?${queryString}`
            : 'Journeys/comparison',
          method: 'get',
        };
      },
      providesTags: (_result, _error, arg) => [
        {
          type: 'JourneyComparison',
          id: `${arg.fromDate ?? ''}_${arg.toDate ?? ''}`,
        },
      ],
    }),
  }),
});

export const { useGetJourneyComparisonQuery } = comparisonApi;
export default comparisonApi;
